import React from 'react';

import { BackButton, Topography } from 'components/ui';

import styles from './CreateRequestHeader.module.scss';

type CreateRequestHeaderProps = {
  title: string;
  backTo?: string;
  onBackClick?: () => void
};

export const CreateRequestHeader: React.FC<CreateRequestHeaderProps> = ({ title, backTo, onBackClick }) => (
  <>
    <BackButton className={styles.back} back={backTo} onBackClick={onBackClick} />
    <Topography.H3>{title}</Topography.H3>
    
  </>
);
